import MaterialReactTable, { MRT_ColumnDef } from "material-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { isQueryClicked, runCustomQuery } from "../atom/atoms";
import useGetCustomQuery from "../hooks/useGetCustomQuery";

interface CustomReportQueryProps {}

const CustomReportQueryBuilder: React.FC<CustomReportQueryProps> = ({}) => {
  const customQuery = useRecoilValue(runCustomQuery);
  const [isQueryClick, setIsQueryClick] = useRecoilState(isQueryClicked);
  // const [dataTable, setDataTable] = useState<any>([]);
  const { data: customData, isFetching: isLoading } = useGetCustomQuery(
    customQuery,
    isQueryClick
  );
  useEffect(() => {
    if (isQueryClick && !isLoading) {
      setIsQueryClick(false);
    }
  }, [isQueryClick, isLoading]);

  const dataColumn = useMemo<MRT_ColumnDef<any>[]>(
    () => (!isLoading && customData?.column ? customData.column : []),
    [customData?.column, isLoading]
  );

  const dataTable = useMemo(
    () => (!isLoading && customData?.data ? customData.data : []),
    [customData?.data, isLoading]
  );

  return (
    <>
      <div className="m-2 bg-white box-shadow rounded-lg h-full overflow-x-auto">
        <div className="text-quinary font-bold font-sans py-2 px-4">Result</div>
        <div>
          <div className="box-shadow mx-4 mb-2 mt-2 overflow-x-auto grid grid-row">
            <MaterialReactTable
              columns={dataColumn}
              data={dataTable ?? []}
              state={{
                density: "compact",
                isLoading: isLoading,
              }}
              enableColumnActions={false}
              enableColumnFilters={false}
              enablePagination={isLoading ? false : true}
              enableSorting={true}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              muiTableHeadCellProps={{
                align: "left",
              }}
              muiTableBodyCellProps={{ align: "left" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomReportQueryBuilder;
